var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6882_15039)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5715 0.251788C12.9195 0.000744253 12.2275 0.00175654 11.4459 0.0028877C9.35352 0.00285793 8.10799 0.0032812 6.01169 0.0028877C3.94264 0.00249932 2.52514 -0.0895262 1.5171 0.797113C1.14708 1.12258 0.810032 1.49028 0.511692 1.89394C-0.121383 2.7505 0.0116302 5.15092 0.0116718 7.00293C0.0117168 9.00293 0.0116652 9.92857 0.0116926 12.2112V19.0184C0.0116515 21.6707 0.0116926 26.0027 0.0116926 26.0027C0.0116926 26.0027 0 29.5 0.999974 30.5C2.39991 31.9 4.01172 32.0027 5.98183 32.0027C8.37626 32.0027 9.67773 32.0029 12.109 32.0027C14.5403 32.0029 15.7246 32.0027 18.0413 32.0027C20.0117 32.0027 22 32 23 30.5C24 29 24.0114 28.0158 24.0114 26.0027C24.0114 23.4741 24.0114 21.6706 24.0114 19.0183L24.0115 13.8474C24.0129 12.86 24.0141 11.9837 23.7069 11.1744C23.3996 10.3651 22.8307 9.74644 22.1898 9.04936L15.6304 1.89376C15.0786 1.29002 14.5899 0.755588 13.9662 0.430125C13.8376 0.363044 13.7059 0.303524 13.5715 0.251788ZM21.2433 12.2876H16.6876C16.6876 12.2876 13.9085 12.2876 13 11.5C12.0915 10.7124 12 9.19111 12 8C12 6.32789 12 3.00665 12 3.00665C14.6498 5.50474 21.2433 12.2876 21.2433 12.2876ZM19.5117 24.5027C19.5117 23.5027 18.6093 23.0027 18.0413 23.0027H5.98183C5.41376 23.0027 4.51169 23.4967 4.51169 24.5027C4.51169 25.5027 5.41376 26.0027 5.98183 26.0027H18.0413C18.6093 26.0027 19.5117 25.5027 19.5117 24.5027ZM12 16.065C12.568 16.065 13.5 16.5184 13.5 17.5184C13.5 18.5184 12.568 19.0184 12 19.0184L6.01169 19.0027C5.44362 19.0027 4.49481 18.6053 4.51169 17.5027C4.52857 16.4002 5.44362 16.0492 6.01169 16.0492L12 16.065Z",
    fill: "#BABEC7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6882_15039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.7747fca3da70e33e8bb9c7e87a0a21a3.svg";
export { ForwardRef as ReactComponent };